import service from '@/api/skill';

export const state = {
    service: service('organizations/skills'),
}

export const getters = {}

export const mutations = {}

export const actions = {}
